module.exports = __webpack_public_path__ + "media/images/giftcards/select-a-giftcard-5687276cf5045bd75f89b7f405849997.svg";